import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService } from 'modules/core/services/auth.service';
import { CurrentUser } from 'modules/shared/models/account.models';

import { AppState } from 'store/root-reducer';
import * as AuthActions from 'store/actions/auth.actions';

@Component({
  selector: 'artemis-dow-jones3-detail',
  templateUrl: './dow-jones3-detail.component.html',
  styleUrls: ['./dow-jones3-detail.component.scss']
})
export class DowJones3DetailComponent implements OnInit {

  dj3DetailData: any;
  recordType: string;
  isShowSection: any =  {
    isShowLastReviewDay: false,
    isShowAlsoKnownAs: false,
    isShowCountryDetails: false,
    isShowAddressDetails: false,
    isShowWatchList: false,
    isShowProfileNotes: false,
    isShowAdditionalDetails: false,
    isShowAdditionalDetailsCorporate: false,
    isShowIndustries: false,
    isShowIdentityDetails: false,
    isShowPrimaryRoles: false,
    isShowPreviousRoles: false,
    isShowOtherRoles: false,
    isShowKnownAssociate: false,
    isShowImage: false,
    isShowSourceDetails: false,
    isAdverseMediaDetails: false,
    isStateOwnedCompanyDetail: false,
    isAssociatedEntity: false,
    isRisks: false,
    isListReference: false,
    isPrimary: false,
    isSpellingVariations: false,
    isAssociatedEntities: false,
    isReportedAffectedEntities: false,
    isReportedAssociatedEntities: false
  };

  @ViewChild('content', {static: false}) content: ElementRef;
  constructor(
    private dialogRef: MatDialogRef<any>,
    private authService: AuthService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const data = _.cloneDeep(this.data);
    if (data) {
      this.recordType = this.data.recordType;
      this.dj3DetailData = data;
      this.handleShowSection(data);
    }

    this.authService.getUser(true)
      .pipe(
        map((user: CurrentUser) => user),
        catchError((err: any) => {
          if (err === 'NotAuthenticated') {
            this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: false }));
            return of(null);
          } else {
            return throwError(err);
          }
        })
      )
      .subscribe((user: CurrentUser) => {
        if (user) {
          // this._currentToken = user.signInUserSession.accessToken.jwtToken;
        }
      });
  }


  closeDialog() {
    this.dialogRef.close();
  }

  simpleDateFormat(data: string) {
    if (data) {
      const date = new Date(data);
      return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
    }
  }

  handleShowSection(dataDJ3: any) {
    if (dataDJ3 && dataDJ3.searchResponse.data) {
      dataDJ3.searchResponse.data.forEach(searchResponseItem => {
        if (searchResponseItem && searchResponseItem.attributes) {
          if (searchResponseItem.attributes.lastReviewedDate) {
            this.isShowSection.isShowLastReviewDay = true;
          }
          if (searchResponseItem.attributes.nameDetails && searchResponseItem.attributes.nameDetails.alsoKnownAs) {
            this.isShowSection.isShowAlsoKnownAs = true;
          }
          if (searchResponseItem.attributes.countryTerritoryDetails) {
            this.isShowSection.isShowCountryDetails = true;
          }
          if (searchResponseItem.attributes.addressDetails) {
            this.isShowSection.isShowAddressDetails = true;
          }
          if (searchResponseItem.attributes.contentTypeDetails) {
            this.isShowSection.isShowWatchList = true;
          }
          if (searchResponseItem.attributes.commentDetails && (searchResponseItem.attributes.commentDetails.listComment
              || searchResponseItem.attributes.commentDetails.siComment)) {
            this.isShowSection.isShowProfileNotes = true;
          }
          if ((searchResponseItem.attributes.countryTerritoryDetails
              || searchResponseItem.attributes.placesOfBirth
              || searchResponseItem.attributes.isDeceased
              || (searchResponseItem.attributes.dateDetails && searchResponseItem.attributes.dateDetails.inactiveAsOfDate))
              && (searchResponseItem.attributes.assetType === 'person')
              ) {
            this.isShowSection.isShowAdditionalDetails = true;
          }
          if ((searchResponseItem.attributes.dateDetails && searchResponseItem.attributes.dateDetails.registration)
            && (searchResponseItem.attributes.assetType === 'entity')) {
            this.isShowSection.isShowAdditionalDetailsCorporate = true;
          }
          if (searchResponseItem.attributes.industries) {
            this.isShowSection.isShowIndustries = true;
          }
          if (searchResponseItem.attributes.identificationDetails) {
            this.isShowSection.isShowIdentityDetails = true;
          }
          if (searchResponseItem.attributes.roleDetails && searchResponseItem.attributes.roleDetails.primary
            && (searchResponseItem.attributes.assetType === 'watchlist')) {
            this.isShowSection.isShowPrimaryRoles = true;
          }
          if (searchResponseItem.attributes.roleDetails && searchResponseItem.attributes.roleDetails.previous
              && (searchResponseItem.attributes.assetType === 'watchlist')) {
            this.isShowSection.isShowPreviousRoles = true;
          }
          if (searchResponseItem.attributes.roleDetails && searchResponseItem.attributes.roleDetails.other
            && (searchResponseItem.attributes.assetType === 'watchlist')) {
            this.isShowSection.isShowOtherRoles = true;
          }
          if (searchResponseItem.attributes.connectionDetails && (searchResponseItem.attributes.assetType === 'relationship')) {
            this.isShowSection.isShowKnownAssociate = true;
          }
          if (searchResponseItem.attributes.imageDetails && (searchResponseItem.attributes.assetType === 'image')) {
            this.isShowSection.isShowImage = true;
          }
          if (searchResponseItem.attributes.sources) {
            searchResponseItem.attributes.sources.forEach(source => {
              if (source.externalLink) {
                this.isShowSection.isShowSourceDetails = true;
              }
            });
          }
          if (searchResponseItem.attributes.adverseMediaDetails || searchResponseItem.attributes.contentTypeDetails
            || searchResponseItem.attributes.assetType === 'adverse_media_entity') {
            this.isShowSection.isAdverseMediaDetails = true;
          }
          if ((searchResponseItem.attributes.stateOwnedCompanyDetail || searchResponseItem.attributes.contentTypeDetails)
            && searchResponseItem.attributes.assetType === 'state_owned_company') {
            this.isShowSection.isStateOwnedCompanyDetail = true;
          }
          if (searchResponseItem.attributes.associatedEntityDetails
            && (searchResponseItem.attributes.associatedEntityDetails.associatedEntities
              || searchResponseItem.attributes.associatedEntityDetails.reportedAssociatedEntities
              || searchResponseItem.attributes.associatedEntityDetails.reportedAffectedEntities
              || searchResponseItem.attributes.associatedEntityDetails.associatedEntities)) {
            this.isShowSection.isAssociatedEntity = true;
          }
          if (searchResponseItem.attributes.associatedEntityDetails
            && searchResponseItem.attributes.associatedEntityDetails.reportedAssociatedEntities) {
              this.isShowSection.isReportedAssociatedEntities = true;
          }
          if (searchResponseItem.attributes.associatedEntityDetails
            && searchResponseItem.attributes.associatedEntityDetails.reportedAffectedEntities) {
              this.isShowSection.isReportedAffectedEntities = true;
          }
          if (searchResponseItem.attributes.associatedEntityDetails
            && searchResponseItem.attributes.associatedEntityDetails.associatedEntities) {
              this.isShowSection.isAssociatedEntities = true;
          }
          if (this.recordType === 'INDIVIDUAL') {
            if (searchResponseItem.attributes.assetType === 'person' && searchResponseItem.attributes.iconHints ) {
              this.isShowSection.isRisks = true;
            }
          } else {
            if (searchResponseItem.attributes.assetType === 'entity' && searchResponseItem.attributes.iconHints ) {
              this.isShowSection.isRisks = true;
            }
          }
          if (searchResponseItem.attributes.assetType === 'list_reference' && searchResponseItem.attributes.sanctionsLists) {
            this.isShowSection.isListReference = true;
          }
          if (searchResponseItem.attributes.nameDetails && searchResponseItem.attributes.nameDetails.primaryName) {
            this.isShowSection.isPrimary = true;
          }
          if (searchResponseItem.attributes.nameDetails && searchResponseItem.attributes.nameDetails.primaryName.associatedNames
            && searchResponseItem.attributes.nameDetails.primaryName.associatedNames.spellingVariations) {
            this.isShowSection.isSpellingVariations = true;
          }
        }
      });
    }
  }
  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  isExistContentTypeDetails(data: Array<any>): boolean {
    let result;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].attributes.contentTypeDetails) {
          result = true;
          break;
        } else {
          result = false;
        }
      }
    }
    return result;
  }
  isAdverseMediaEntity(data: Array<any>): boolean {
    let result;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].attributes.assetType === 'adverse_media_entity') {
          result = true;
          break;
        } else {
          result = false;
        }
      }
    }
    return result;
  }

  getSubDescription(data: Array<any>) {
    let str = '';
    if (data) {
      data.forEach(e => {
        str += e.description;
        if (e['level'] && e['subContentTypes']) {
          str += `, ${this.getSubDescription(e['subContentTypes'])}`;
        }
      });
    }
    return str;
  }
  getDescription(arr: Array<any>): string {
    const result = [];
    arr.forEach(e => {
      result.push(e.description);
      if (e['level']) {
        result.push(this.getSubDescription(e['subContentTypes']));
      }
    });
    if (result[result.length - 1] === '') {
      result.splice(result.length - 1 , 1);
    }
    return result.join(', ');
  }
}
